export default __webpack_public_path__ + "static/media/Summary.9c8512ec.svg";